import { Form as Form$1 } from "./auth-fe15.esm.js";
import React, { forwardRef, useEffect, useState } from "react";
import { AccountFormControls, Box, EmailInput } from "@opendoor/bricks-next";
//#region src/AccountForm/AccountFormCinderblocks/AccountEmailForm.tsx
var AccountEmailForm = forwardRef(({ showForgotPassword = true, analyticsName, loading, openForgotPasswordInNewTab, onSubmit, email: initialEmail = "" }, ref) => {
	const [prefillEmail, setPrefillEmail] = useState(initialEmail);
	const [email, setEmail] = useState(initialEmail);
	const [hasError, setHasError] = useState(false);
	const maybePrefillEmail = () => {
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.searchParams);
		if (params.get("email")) setPrefillEmail(params.get("email") || initialEmail);
	};
	useEffect(() => {
		maybePrefillEmail();
	}, []);
	const handleSubmit = (e) => {
		e.preventDefault();
		if (!hasError) onSubmit(email);
		if (ref && "current" in ref && ref.current) ref.current.focus();
	};
	const handleValidityChange = (validity) => {
		setHasError(validity !== "valid");
		if (validity !== "valid" && ref && "current" in ref && ref.current) ref.current.focus();
	};
	const isDisabled = hasError || !email;
	return /* @__PURE__ */ React.createElement(Form$1, { onSubmitCapture: handleSubmit }, /* @__PURE__ */ React.createElement(Box, { gap: "$4x" }, /* @__PURE__ */ React.createElement(EmailInput, {
		ref,
		analyticsName,
		title: "Email",
		getValue: (value) => setEmail(value.unformattedValue == null ? "" : value.unformattedValue),
		onValidationChange: handleValidityChange,
		prefilledValue: prefillEmail,
		fieldRequiredError: "This field is required",
		invalidEmailError: "Please enter a valid email address",
		size: "medium"
	}), /* @__PURE__ */ React.createElement(AccountFormControls, {
		actionText: "Continue with email",
		analyticsName,
		loading,
		disabled: isDisabled,
		openForgotPasswordInNewTab,
		submitA11yProps: { "aria-label": "" },
		showForgotPassword,
		forgotPasswordText: "Forgot your password?",
		forgotPasswordAriaNewWindow: "Opens a new window with the forgot password page",
		forgotPasswordAriaSameWindow: "Opens the forgot password page"
	})));
});
AccountEmailForm.displayName = "AccountEmailForm";
//#endregion
export { AccountEmailForm as default };

